import { render, staticRenderFns } from "./MaintenanceMode.vue?vue&type=template&id=87bc2028&scoped=true"
import script from "./MaintenanceMode.vue?vue&type=script&lang=js"
export * from "./MaintenanceMode.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceMode.vue?vue&type=style&index=0&id=87bc2028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bc2028",
  null
  
)

export default component.exports